import { IHeader } from '@/.generated';
import { visibleNavLinks } from './visibleNavLinks';

type NavLevelOneItem = NonNullable<IHeader['nav_level_one']>[number];
type NavColumn = NonNullable<NavLevelOneItem['nav_columns']>[number];

// Determine whether an L1 entry has any content worth opening a mega menu for.
// V2 nests the deeper levels per-link, so we walk links → L3 groups. The header
// renders up to L3 only, so detection stops at L3 to avoid opening an empty menu.
export const hasMegaMenuContent = (item: NavLevelOneItem): boolean => {
  if (item.show_account_login_section) return true;
  if (item.featured_section?.featured_content) return true;
  if (item.featured_section?.featured_image?.image?.url) return true;

  const columns = (item.nav_columns ?? []) as NavColumn[];

  // Count only visible links so an L1 whose only entries are hidden doesn't open an empty menu.
  return columns.some(
    (col) =>
      visibleNavLinks(col.nav_level_one_links).length > 0 ||
      col.nav_level_two?.some(
        (l2) =>
          visibleNavLinks(l2.navigation_level_two_links).length > 0 ||
          l2.navigation_level_two_links?.some((l2Link) =>
            l2Link.navigation_level_three?.some(
              (l3) => visibleNavLinks(l3.navigation_level_three_links).length > 0
            )
          )
      )
  );
};
